<template>
  <div
    class="compete-btn"
    v-on="$listeners"
    :style="btnStyles"
    :class="btnClass"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  name: "CompButton",
  props: {
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: "default", // default middle
    },
    type: {
      type: String,
      default: "promary", // default, promary, info, error, warn, custom自定义
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    btnStyles() {
      return this.type === "custom"
        ? {
            width: this.width ? this.width + "px" : "100px",
            height: this.height ? this.height + "px" : "36px",
          }
        : {};
    },
    btnClass() {
      return [
        "btn-" + this.type,
        this.size + "-size",
        {
          disable: this.disabled,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.compete-btn {
  display: inline-block;
  min-width: 100px;
  font-family: "PingFangSC-Regular", Arial, "Microsoft Yahei", sans-serif,
    Verdana, "PingFang SC";
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
  white-space: nowrap;
  &.disable {
    cursor: not-allowed;
    opacity: 0.5;
  }
  &.btn-custom {
    display: "inline-flex";
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }
  &.btn-promary {
    background-color: #3060ff;
    background-image: linear-gradient(42deg, #3060ff 0%, #5db7ff 100%);
    color: #fff;
    &:not(.disable):hover {
      background-image: linear-gradient(42deg, #5d84ff 0%, #7bc0ff 100%);
    }
  }
  &.btn-default {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    color: #333333;
    &:hover {
      border-color: #3060ff;
      color: #3060ff;
    }
  }
  &.btn-info {
    background-color: #fff;
    border: 1px solid #3060ff;
    color: #3060ff;
    &:hover {
      border-color: #5d84ff;
      color: #5d84ff;
    }
  }
  &.default-size {
    padding: 5px 16px;
    font-size: 14px;
    line-height: 22px;
    border-radius: 16px;
  }
  &.middle-size {
    padding: 8px 16px;
    border-radius: 16px;
    font-size: 16px;
    line-height: 24px;
  }
  &.large-size {
    padding: 8px 24px;
    border-radius: 16px;
    font-size: 16px;
    line-height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/common/CompButton.vue